import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PlatformAdmin from './PlatformAdmin';

// admin.txcoordinatorpro.com is a completely separate entry point from the
// brokerage-tenant app — the operator's login isn't tied to any brokerage,
// so it's kept out of App()'s tenant auth state machine entirely rather than
// branched inside it. The localhost ?admin=1 escape hatch is for local dev,
// since the hostname check obviously never matches there.
const isPlatformAdminHost =
  window.location.hostname === 'admin.txcoordinatorpro.com' ||
  (window.location.hostname === 'localhost' && new URLSearchParams(window.location.search).get('admin') === '1');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(isPlatformAdminHost ? <PlatformAdmin /> : <App />);
